import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartPie } from "@fortawesome/free-solid-svg-icons";
import './dashCSS.css';
import api from '../conexao.js';
import { format} from 'date-fns';

// Registra os componentes necessários do Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function DashProcedimentos() {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [],
    });
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const dataHoje = new Date();
    useEffect(() => {
        // Função para buscar e processar os dados da API
        const fetchData = async () => {
            try {
                // 1. Busca os agendamentos
                const response = await api.get('/imprimeagenda', { 
                    params: {           
                         data: format(dataHoje,'yyyy-MM-dd')
                    }
                });
             
                // console.log(response.data)
                const agendaData = response.data;

                if (!Array.isArray(agendaData)) {
                    throw new Error('Falha ao buscar dados da agenda');
                }

                if (agendaData.length === 0) {
                    setTotal(0);
                    setChartData({ labels: [], datasets: [] });
                    return;
                }

                // 2. Extrai os códigos de situação únicos
                const situacaoIds = [...new Set(agendaData.map(item => item.COD_SITUACAO).filter(id => id != null))];

                // 3. Busca as descrições para cada código em paralelo
                const situacaoPromises = situacaoIds.map(id =>
                    api.get('/situacao', { params: { codigo: id } })
                );
                const situacaoResponses = await Promise.all(situacaoPromises);

                // 4. Cria um mapa para busca rápida: { codigo: descricao }
                const situacoesMap = situacaoResponses.reduce((acc, res) => {
                    const situacao = res.data;
                    if (situacao && situacao.CODIGO) {
                        acc[situacao.CODIGO] = situacao.DESCRICAO || `Situação ${situacao.CODIGO}`;
                    }
                    return acc;
                }, {});

                // 5. Processa os dados da agenda usando as descrições do mapa
                const procedureCounts = agendaData.reduce((acc, current) => {
                    const procedureName = situacoesMap[current.COD_SITUACAO] || 'Não definido';
                    acc[procedureName] = (acc[procedureName] || 0) + 1;
                    return acc;
                }, {});

                const labels = Object.keys(procedureCounts);
                const counts = Object.values(procedureCounts);
                const totalProcedures = counts.reduce((sum, count) => sum + count, 0);

                setTotal(totalProcedures);
                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Quantidade',
                            data: counts,
                            backgroundColor: [
                                'rgba(54, 162, 235, 0.7)',
                                'rgba(255, 99, 132, 0.7)',
                                'rgba(75, 192, 192, 0.7)',
                                'rgba(255, 206, 86, 0.7)',
                                'rgba(153, 102, 255, 0.7)',
                                'rgba(255, 159, 64, 0.7)',
                            ],
                            borderColor: [
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 99, 132, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                            ],
                            borderWidth: 1,
                        },
                    ],
                });
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []); // O array vazio faz com que o useEffect rode apenas uma vez

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0
                }
            }
        },
        plugins: {
            legend: {
                display: false
            },
        },
    };
    
    // Renderização condicional
    if (loading) {
        return <div className="containerDash"><center>Carregando dados dos procedimentos...</center></div>;
    }

    if (error) {
        return <div className="containerDash"><center>Erro: {error}</center></div>;
    }

    return (
        <center>
            <div className='containerDash'>
                <div>
                    <h5>Procedimentos</h5>
                    <h6>Total: {total}</h6>
                </div>
                <div><FontAwesomeIcon icon={faChartPie} size='xl' /></div>
            </div>
            <div className='containerGrafico'>
                {/* O gráfico só será renderizado se houver dados */}
                {chartData.labels.length > 0 ? (
                    <Bar data={chartData} options={chartOptions} />
                ) : (
                    <p>Nenhum procedimento encontrado.</p>
                )}
            </div>
        </center>
    );
}